var _path, _mask, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6142 13.9991c0 1.9944-1.6168 3.6111-3.6112 3.6111-1.9943 0-3.6111-1.6167-3.6111-3.6111 0-1.9943 1.6168-3.6111 3.6111-3.6111 1.9944 0 3.6112 1.6168 3.6112 3.6111z",
    stroke: "#fff",
    strokeWidth: 1.66667
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5013 10.1107c.4602 0 .8333-.37311.8333-.83335 0-.46024-.3731-.83333-.8333-.83333-.4602 0-.8333.37309-.8333.83333 0 .46024.3731.83335.8333.83335z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5013 10.1107c.4602 0 .8333-.37311.8333-.83335 0-.46024-.3731-.83333-.8333-.83333-.4602 0-.8333.37309-.8333.83333 0 .46024.3731.83335.8333.83335z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.668 9.27735c0-.46024.3731-.83333.8333-.83333v3.33328c1.3807 0 2.5-1.1192 2.5-2.49995H20.668zm.8333-.83333c.4602 0 .8333.37309.8333.83333h-3.3333c0 1.38075 1.1193 2.49995 2.5 2.49995V8.44402zm.8333.83333c0 .46024-.3731.83335-.8333.83335V6.77735c-1.3807 0-2.5 1.11929-2.5 2.5h3.3333zm-.8333.83335c-.4602 0-.8333-.37311-.8333-.83335h3.3333c0-1.38071-1.1193-2.5-2.5-2.5v3.33335z",
    fill: "#fff",
    mask: "url(#a)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63507 5.94293c.23385 0 .45694-.09826.6148-.27079l1.37263-1.50012c.2631-.28755.6349-.45131 1.0247-.45131h4.7091c.3898 0 .7616.16376 1.0247.45131l1.3726 1.50012c.1579.17253.381.27079.6148.27079h3.5222c.762 0 1.3889.6269 1.3889 1.38889V20.6652c0 .7619-.6269 1.3888-1.3889 1.3888H5.11285c-.76199 0-1.38889-.6269-1.38889-1.3888V7.33182c0-.76199.6269-1.38889 1.38889-1.38889h3.52222z",
    stroke: "#fff",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.6a5ae2c5.svg";
export { ForwardRef as ReactComponent };